var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
import React from "react";
import Icon from "@ant-design/icons";
var FiltersSvg = /* @__PURE__ */ __name(function FiltersSvg2() {
  return /* @__PURE__ */ React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 72 72"
  }, /* @__PURE__ */ React.createElement("g", {
    id: "Layer_1"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M70.1,33.1H32.2C31.1,29,27.4,26,22.9,26s-8.2,3.1-9.4,7.2H1.6v5.1h11.9c1.1,4.1,4.9,7.2,9.4,7.2s8.2-3.1,9.4-7.2h37.9 V33.1z M22.9,40.8c-2.8,0-5.1-2.3-5.1-5.1c0-2.8,2.3-5.1,5.1-5.1s5.1,2.3,5.1,5.1C28,38.5,25.7,40.8,22.9,40.8z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M70.1,55.7H54.5c-1.1-4.1-4.9-7.2-9.4-7.2s-8.2,3-9.4,7.2H1.6v5.1h34.2c1.1,4.1,4.9,7.2,9.4,7.2s8.3-3.1,9.4-7.2h15.6V55.7 z M45.2,63.4c-2.8,0-5.1-2.3-5.1-5.1c0-2.8,2.3-5.1,5.1-5.1c2.8,0,5.1,2.3,5.1,5.1C50.3,61.1,48,63.4,45.2,63.4z"
  }), /* @__PURE__ */ React.createElement("path", {
    d: "M70.1,10.9h-7.5c-1.1-4.1-4.9-7.2-9.4-7.2s-8.2,3.1-9.4,7.2H1.6v5.1h42.3c1.1,4.1,4.9,7.2,9.4,7.2s8.2-3.1,9.4-7.2h7.5 V10.9z M53.3,18.5c-2.8,0-5.1-2.3-5.1-5.1s2.3-5.1,5.1-5.1c2.8,0,5.1,2.3,5.1,5.1S56.1,18.5,53.3,18.5z"
  })), /* @__PURE__ */ React.createElement("g", {
    id: "Layer_2"
  }));
}, "FiltersSvg");
var FiltersIcon = /* @__PURE__ */ __name(function FiltersIcon2(props) {
  return /* @__PURE__ */ React.createElement(Icon, _extends({
    component: FiltersSvg
  }, props));
}, "FiltersIcon");
export {
  FiltersIcon
};
